import React, { useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import RightCreateForm from './RightCreateForm'
import FormDrawerWrapper from '../../../../../features/components/FormDrawerWrapper'

import useManageDrawer from '../../../../../hooks/formHooks/useManageDrawer'
import { useIsGamAccountConnectedToRightsHolderAccount } from './RightCreateForm/sectionsLists/OnsiteRightCreateSections/GamOnsiteRightCreateSections/hooks'

import { getChoicesAllocationUnits } from '../../../../../modules/actions/choices'

import { choicesAllocationUnitsWasLoadedSelector } from '../../../../../modules/selectors/choices'
import { clearGetOnsiteRates, getOnsiteRates } from '../../../../../modules/actions/googleAdManager'
import { getOnsiteRatesWasLoadedSelector } from '../../../../../modules/selectors/googleAdManager'
import { selfAccountWasLoadedSelector } from '../../../../../modules/selectors/selfAccounts'

import { RIGHT_CREATE } from '../../../../../constants/forms'
import { selectedPartnershipRightsHolderIdSelector } from '../../../../../modules/selectors/partnerships'
import { getSelfAccount } from '../../../../../modules/actions/selfAccounts'

function CreateRight() {
  const dispatch = useDispatch()

  const choicesAllocationUnitsWasLoaded = useSelector(choicesAllocationUnitsWasLoadedSelector)
  const getOnsiteRatesWasLoaded = useSelector(getOnsiteRatesWasLoadedSelector)

  const rightHolderAccountId = useSelector(selectedPartnershipRightsHolderIdSelector)
  const selfAccountWasLoaded = useSelector(selfAccountWasLoadedSelector)

  const { isFormOpen } = useManageDrawer({
    formName: RIGHT_CREATE
  })

  const isGamAccountConnected = useIsGamAccountConnectedToRightsHolderAccount()

  const isFormLoading = useMemo(() => {
    if (isGamAccountConnected) {
      return !getOnsiteRatesWasLoaded
    } else {
      return !selfAccountWasLoaded
    }
  }, [isGamAccountConnected, getOnsiteRatesWasLoaded, selfAccountWasLoaded])

  useEffect(() => {
    if (isFormOpen && !selfAccountWasLoaded) {
      dispatch(getSelfAccount(rightHolderAccountId))
    }
  }, [dispatch, isFormOpen, selfAccountWasLoaded, rightHolderAccountId])

  useEffect(() => {
    if (isFormOpen && !choicesAllocationUnitsWasLoaded) {
      dispatch(getChoicesAllocationUnits())
    }
  }, [dispatch, isFormOpen, choicesAllocationUnitsWasLoaded])

  useEffect(() => {
    if (isGamAccountConnected) {
      if (isFormOpen && !getOnsiteRatesWasLoaded) {
        dispatch(getOnsiteRates())
      }

      if (!isFormOpen && getOnsiteRatesWasLoaded) {
        dispatch(clearGetOnsiteRates())
      }
    }
  }, [dispatch, isGamAccountConnected, isFormOpen, getOnsiteRatesWasLoaded])

  return (
    <FormDrawerWrapper
      formName={RIGHT_CREATE}
      title="Create a new right"
      showOpenButton={false}
      isFormLoading={isFormLoading}
    >
      <RightCreateForm />
    </FormDrawerWrapper>
  )
}

export default CreateRight
